module.exports = __webpack_public_path__ + "img/GroupAdvert.c6808408.png";